/* Site-page kit behaviour.
   Capsule close (.k-cap[data-kcap]): opens as you scroll, like the Daily Restore page (c9-capsule-scrub.js). Frames are drawn on a
   canvas (video seeking stutters on iOS). No pinning: closed as the capsule rises from the bottom of the screen, open by the middle,
   reversing on the way back up. Reduced motion or frames that fail to load: the opened still. Without frames: plays the video once. */
(() => {
  const calm = matchMedia("(prefers-reduced-motion: reduce)").matches;
  document.querySelectorAll("[data-kcap]").forEach((fig) => {
    if (fig.dataset.kcapOn) return; fig.dataset.kcapOn = "1";
    const media = fig.querySelector(".k-cap-media");
    const done = () => { fig.classList.add("done"); };
    let urls = []; try { urls = JSON.parse(fig.dataset.seq || "[]"); } catch (e) {}
    if (calm) { done(); return; }
    if (urls.length) {
      const cv = document.createElement("canvas"); cv.className = "k-cap-canvas"; cv.setAttribute("aria-hidden", "true"); media.appendChild(cv);
      const ctx = cv.getContext("2d"), frames = new Array(urls.length);
      let loaded = 0, started = false, last = -1, raf = 0;
      const size = () => { const r = media.getBoundingClientRect(), d = Math.min(window.devicePixelRatio || 1, 2); const w = Math.round(r.width * d), h = Math.round(r.height * d); if (w === cv.width && h === cv.height) return; cv.width = w; cv.height = h; last = -1; draw(); };  /* iOS fires resize whenever the address bar moves: only rebuild on a real size change */
      const progress = () => { const r = fig.getBoundingClientRect(), vh = innerHeight, c = r.top + r.height / 2; return Math.pow(Math.max(0, Math.min(1, (vh - c) / (vh * 0.5))), 1.3); };
      const nearest = (i) => { for (let k = 0; k < frames.length; k++) { if (frames[i - k] && frames[i - k].naturalWidth) return frames[i - k]; if (frames[i + k] && frames[i + k].naturalWidth) return frames[i + k]; } return null; };
      function draw() {
        raf = 0; if (!loaded) return;
        const p = progress(), i = Math.round(p * (urls.length - 1));
        fig.classList.toggle("open", p >= 0.97);
        if (i === last) return;
        const img = nearest(i); if (!img) return;
        last = i; ctx.clearRect(0, 0, cv.width, cv.height); ctx.drawImage(img, 0, 0, cv.width, cv.height);
      }
      const request = () => { if (!raf) raf = requestAnimationFrame(draw); };
      const load = () => {
        if (started) return; started = true;
        [0, urls.length - 1].concat(urls.map((_, k) => k).slice(1, -1)).forEach((k) => {
          const im = new Image(); im.decoding = "async"; im.src = urls[k];
          im.onload = () => { loaded++; if (loaded === 1) { fig.classList.add("scrub"); size(); } request(); };
          im.onerror = () => { if (k === 0) { cv.remove(); done(); } };
          frames[k] = im;
        });
      };
      new IntersectionObserver((es, o) => { if (es[0].isIntersecting) { o.disconnect(); load(); } }, { rootMargin: "900px 0px" }).observe(fig);
      addEventListener("scroll", request, { passive: true }); addEventListener("resize", size);
      return;
    }
    const vid = fig.querySelector(".k-cap-vid");
    if (!vid || !vid.canPlayType("video/mp4")) { done(); return; }
    const load = () => { if (!vid.getAttribute("src")) { vid.muted = true; vid.playsInline = true; vid.src = vid.dataset.src; vid.preload = "auto"; vid.load(); } };
    vid.addEventListener("ended", () => { fig.classList.remove("playing"); done(); }, { once: true });
    vid.addEventListener("error", done, { once: true });
    const io = new IntersectionObserver((es) => {
      if (!es[0].isIntersecting) return; io.disconnect(); load();
      const go = () => { fig.classList.add("playing"); vid.playbackRate = 2; const p = vid.play(); if (p) p.catch(done); };
      if (vid.readyState >= 3) go(); else vid.addEventListener("canplay", go, { once: true });
    }, { threshold: 0.6 });
    io.observe(fig);
  });
})();
